<!-- =========================================================================================
  File Name: FullPage.vue
  Description: Full page layout
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--full-page">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
  components: {

  },
  data () {
    return {
      
    }
  },
  watch: {
    
  },
  computed: {
  },
  methods: {
    removeElementsByClass(className){
      const elements = document.getElementsByClassName(className);
      while(elements.length > 0){
          elements[0].parentNode.removeChild(elements[0]);
      }
    },
  },
  created () {
    this.removeElementsByClass('con-vs-popup')
  },
  beforeDestroy () {
    
  }
}
</script>
